/*
    Add here your own custom javascript ​‍‍‌​‍‍‍‍​‌‌​‍​‍‌‍‍⁠‌​​‌‍​‌​​‍​‌​‌‍​‌‌‌‍​​​‌‍​​‌‌‍​‌‌​‍​​‌‌‍​​​​‍​‌​​‍​​‌​‍​​​‌‍​​​​﻿‍‍‍‍​‍​‌‍​‌‍‍‍​‍​​‍‍
*/

// Fix for the RTL language in the demo
document.querySelectorAll('[href="/ar"]').forEach(link => {
    link.setAttribute('target', '_blank')
})
